// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + {"5017":"infoboxcomparison","5663":"credits"}[chunkId] + "." + {"5017":"6ce90c54","5663":"0262ccb4"}[chunkId] + ".css";
};